(() => {
  const getModalInput = () => document.querySelector('#search-modal .search-input');

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-np-search-term]');
    if (!chip) return;

    const input = getModalInput();
    if (!input) return;

    event.preventDefault();
    input.value = chip.dataset.npSearchTerm || chip.textContent.trim();
    input.focus();
    input.dispatchEvent(new InputEvent('input', {
      bubbles: true,
      inputType: 'insertText',
      data: input.value
    }));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#search-modal .predictive-search-form');
    if (!form) return;
    event.preventDefault();
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest?.('#search-modal .search-input');
    if (!input || event.key !== 'Enter') return;

    const selected = document.querySelector('#search-modal [aria-selected="true"] a');
    if (selected) return;

    const firstProduct = document.querySelector(
      '#search-modal .predictive-search-results__card--product .resource-card__link'
    );

    event.preventDefault();
    event.stopImmediatePropagation();

    if (firstProduct) firstProduct.click();
  }, true);
})();